/* Homepage "ADD TO BAG": add via AJAX and slide Dawn's cart drawer in,
   instead of navigating the customer to a cart/checkout form. */
(function () {
  function drawer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  document.addEventListener('submit', function (evt) {
    var form = evt.target.closest && evt.target.closest('form.card-cta-form');
    if (!form) return;

    var cart = drawer();
    if (!cart || typeof window.routes === 'undefined') return; // let it post normally

    evt.preventDefault();
    var btn = form.querySelector('.card-cta');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    var label = btn ? btn.textContent : '';
    if (btn) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-loading');
      btn.textContent = 'Adding…';
    }

    var data = new FormData(form);
    if (cart.getSectionsToRender) {
      data.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      data.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Could not add to bag');
        if (cart.renderContents) cart.renderContents(res);
        else window.location = window.routes.cart_url;
      })
      .catch(function () {
        form.submit();                      // fall back to the normal post
      })
      .finally(function () {
        if (btn) {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('is-loading');
          btn.textContent = label;
        }
      });
  });
})();
